import React from "react";

import { ModalAdapterProps, ModalTypes } from "constants/navigation";
import BusinessRelationHashModal from "components/Business/BusinessRelations/Modal/Modal";

function BusinessRelationModalAdapter(
  props: ModalAdapterProps,
): React.JSX.Element {
  const { hash } = props;
  const hashParams = hash[ModalTypes.BusinessRelations] || null;
  const { relationshipId } = JSON.parse(hashParams);
  const { returnTo } = hash;

  return (
    <BusinessRelationHashModal
      relationshipId={relationshipId}
      returnTo={returnTo ? atob(returnTo) : null}
    />
  );
}

export default BusinessRelationModalAdapter;
